export default __webpack_public_path__ + "static/media/asaba-terminal.4ef1688e.png";